import classNames from 'classnames';
import React from 'react';
import { IList } from 'typings/DeepIMap';
import ColorSection from 'components/Toolbar/Shared/ColorSection';
import Tooltip from 'components/Tooltip';
import { BrandColor, BrandColorMap, ColorsCategory } from 'models';
import styles from './styles.module.scss';

type Props = {
  colorsCategories: IList<ColorsCategory>;
  colors: IList<BrandColor>;
  value?: BrandColorMap;
  onChange: (value: BrandColorMap) => void;
  className?: string;
  tooltipClassName?: string;
  dataTestId?: string;
};

const ColorsList: React.FunctionComponent<Props> = (props) => {
  const {
    colorsCategories,
    colors,
    value,
    onChange,
    className,
    tooltipClassName,
    dataTestId = 'colorsList',
  } = props;

  const [tooltipState, setTooltipState] = React.useState({
    show: false,
    parent: null,
    text: '',
  });

  const toggleTooltipWithOptions = (show = false, text = '', parent = null): void => {
    setTooltipState({ show, parent, text });
  };

  return (
    <div className={classNames(className, styles.colorsList)} data-testid={dataTestId}>
      <div>
        {
          colorsCategories.map((colorsCategory, index) => {
            const name = colorsCategory?.get('name');

            return (
              <ColorSection
                key={name}
                activeColor={value}
                colors={colors.filter(color => colorsCategory.get('brandColors').includes(color.get('name')))}
                title={name}
                toggleColor={onChange}
                toggleTooltip={toggleTooltipWithOptions}
                dataTestId={`${dataTestId}-colorSection${index}`}
              />
            );
          })
        }
      </div>
      <Tooltip
        arrow={false}
        className={classNames(tooltipClassName, styles.colorsListTooltip)}
        parent={tooltipState.parent}
        show={tooltipState.show}
        text={tooltipState.text}
        dataTestId={`${dataTestId}-tooltip`}
      />
    </div>
  );
};

export default ColorsList;
